<span
  class="status-badge"
  [ngClass]="status()"
>{{ BADGE_LABEL[status()] }}</span>
